<template>
  <div>
    <v-divider />

    <div class="d-none d-md-flex justify-space-between align-center pa-3 py-2">
      <div class="d-flex align-center">
        <span class="text-caption grey--text text--darken-1 mr-2">
          Filas por página:
        </span>

        <v-select
          outlined
          full-width
          :value="itemsPorPagina"
          :items="itemsPorPaginaOptions"
          :disabled="loading || itemsPorPaginaOptions.length <= 1"
          :menu-props="{ maxHeight: '300' }"
          :style="{ width: '90px' }"
          v-bind="propsStyles.itemSeleccionado"
          hide-details
          @input="$emit('update:items-por-pagina', $event)"
        />

        <span class="text-caption grey--text text--darken-1 ml-8">
          <template v-if="loading">
            <v-progress-circular
              indeterminate
              size="16"
              width="2"
              class="mr-2"
            />
            Cargando...
          </template>
          <template v-else>
            {{ showedItems }}
          </template>
        </span>
      </div>

      <v-pagination
        color="primary"
        :value="pagina"
        :length="cantidadPaginas"
        :total-visible="9"
        :disabled="loading"
        @input="$emit('update:pagina', $event)"
      />
    </div>

    <div class="d-md-none">
      <!-- Primera fila: Selector de filas por página y contador -->
      <v-row class="px-2 py-0 ma-0" align="center" justify="space-between">
        <v-col cols="auto" class="pa-1">
          <div class="d-flex align-center">
            <span class="text-caption grey--text text--darken-1 mr-2">
              Filas por página:
            </span>
            <v-select
              outlined
              :value="itemsPorPagina"
              :items="itemsPorPaginaOptions"
              :disabled="loading || itemsPorPaginaOptions.length <= 1"
              :menu-props="{ maxHeight: '300' }"
              :style="{ width: '90px' }"
              v-bind="propsStyles.itemSeleccionado"
              class="py-2"
              hide-details
              @input="$emit('update:items-por-pagina', $event)"
            />
          </div>
        </v-col>

        <v-col cols="auto" class="pa-1">
          <span class="text-caption grey--text text--darken-1">
            <template v-if="loading">
              <v-progress-circular
                indeterminate
                size="14"
                width="2"
                class="mr-1"
              />
              Cargando...
            </template>
            <template v-else>
              {{ showedItems }}
            </template>
          </span>
        </v-col>
      </v-row>

      <!-- Segunda fila: Paginación centrada -->
      <v-row class="pa-2 pt-0 ma-0" justify="center">
        <v-col cols="12" class="pa-1">
          <div class="d-flex justify-center">
            <v-pagination
              color="primary"
              :value="pagina"
              :length="cantidadPaginas"
              :total-visible="$vuetify.breakpoint.xs ? 5 : 7"
              :disabled="loading"
              @input="$emit('update:pagina', $event)"
            >
            </v-pagination>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataTablePagination',

  props: {
    pagina: { type: Number, default: 1 },
    itemsPorPagina: { type: Number, default: 10 },
    itemsPorPaginaOptions: {
      type: Array,
      default: () => [10, 50, 100, 200, { text: 'Todos', value: -1 }],
    },
    totalItems: { type: Number, required: true },
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      propsStyles: {
        itemSeleccionado: {
          dense: true,
          singleLine: true,
          class: 'text-caption',
        },
      },
    };
  },

  computed: {
    cantidadPaginas() {
      return Math.ceil(this.totalItems / this.itemsPorPagina);
    },
    startIndex() {
      return (this.pagina - 1) * this.itemsPorPagina + 1;
    },
    endIndex() {
      return Math.min(this.pagina * this.itemsPorPagina, this.totalItems);
    },
    showedItems() {
      return `${this.startIndex} - ${
        this.itemsPorPagina === -1 ? this.totalItems : this.endIndex
      } de ${this.totalItems}`;
    },
  },
};
</script>

<style scoped>
/* Estilos para mejorar la responsividad */
.pagination-mobile {
  max-width: 100%;
  overflow-x: auto;
}

/* Ajustes para pantallas muy pequeñas */
@media (max-width: 600px) {
  .text-caption {
    font-size: 0.75rem !important;
  }

  .v-pagination__item {
    min-width: 28px !important;
    height: 28px !important;
    font-size: 0.75rem !important;
  }

  .v-pagination__navigation {
    min-width: 28px !important;
    height: 28px !important;
  }
}

/* Ajustes para el v-select en móviles */
@media (max-width: 960px) {
  .v-select.v-text-field .v-select__selection {
    font-size: 0.75rem;
  }

  .v-select .v-input__control {
    min-height: 32px !important;
  }
}
</style>
